import { Injectable } from '@angular/core';

/**
 * TinyMCE helper class.
 *
 * @todo Move all Tinymce-related code to this class.
 */
@Injectable({
  providedIn: 'root'
})
export class TinymceService {

  constructor() { }

  /**
   * Normalize / convert value to standardized input.
   *
   * - Patch empty values, which should never be `null` for Paragraph types.
   * - Wrap in <p>-tag for consistent rendering.
   * - Remove all <div>-tags for consistent rendering.
   * - Convert <b> to <strong>.
   *
   * @todo Chain `replace`s?
   *
   * @param value The value to sanitize.
   * @returns Sanitized / normalized value.
   */
  public sanitizeInput(value: string): string {
    if (!value) {
      value = '<p></p>';
    } else if (value.slice(0, 2) !== '<p' && value.slice(-3) !== '/p>') {
      value = `<p>${ value }</p>`;
    }

    // Keep this in case the chaining below doesn't work properly, but don't
    // forget to remove if it proves to work fine.
    // // Replace all div tags by p tags.
    // value = value.replace(/<div/g, '<p');
    // value = value.replace(/<\/div>/g, '</p>');
    // // Remove empty paragraphs.
    // value = value.replace(/<p> <\/p>/g, '');
    // // Remove duplicate opening and closing p tags.
    // value = value.replace(/<p><p/g, '<p');
    // value = value.replace(/<\/p><\/p>/g, '</p>');
    // // Replace all b by strong
    // value = value.replace(/<b/g, '<strong');
    // value = value.replace(/<\/b>/g, '</strong>');

    value = value
      .replace(/<div/g, '<p')           // Replace all div tags by p tags.
      .replace(/<\/div>/g, '</p>')      // Replace all div tags by p tags.
      .replace(/<p> <\/p>/g, '')        // Remove empty paragraphs.
      .replace(/<p><p/g, '<p')          // Remove duplicate opening and closing p tags.
      .replace(/<\/p><\/p>/g, '</p>')   // Remove duplicate opening and closing p tags.
      .replace(/<b/g, '<strong')        // Replace all b tags by strong tags.
      .replace(/<\/b>/g, '</strong>');  // Replace all b tags by strong tags.

    return value;
  }

  /**
   * Fix/sanitize output produced by TinyME.
   *
   * Fixes:
   * - Image upload URLS. Force a base url.
   *
   * @note Mke sure the regex only applies to *images*.
   *
   * @param value The value to sanitize.
   * @returns Sanitized value.
   */
  public sanitizeOutput(value: string): string {

    // Fix image upload URLS caused by TinyMCE's automatic uploader. Somehow the baseURL is not
    // inserted after an upload. It actually works fine, and it's better to not include a base
    // url, however *this breaks the Word addin*.
    value = value.replace(/src="(..\/)*api\/project\/v2/g, `src="${ window.location.origin }/api/project/v2`);
    return value;
  }
}
